
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refund/calculator/sangjo/[id]",
      function () {
        return require("private-next-pages/refund/calculator/sangjo/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refund/calculator/sangjo/[id]"])
      });
    }
  